module.exports={
    "over_size_message":"De afbeelding die je hebt geüpload is meer dan 10MB. We zullen uw bestand comprimeren om te uploaden. Klik op \"Bevestigen\" om door te gaan met uploaden.",
    "file_type_error":"Het bestand dat je hebt geüpload is geen afbeelding! Probeer opnieuw te uploaden.",
    "upload_error":"Uploadfout! (Foutcode: 2000) Probeer het opnieuw.",
    "watermark_remove_over_size":"De afbeelding die je hebt geüpload is meer dan 5MB. Het wordt aanbevolen om onze gratis online beeldcompressor te gebruiken. Klik om <a class=\"jump-link\" href=\"https://www.tipard.com/nl/image-compressor-online/\">meer te leren</a>",
    "watermark_remove_file_type_error":"Het bestand dat je hebt geüpload is geen afbeelding, upload het opnieuw.",
    "watermark_remove_image_type_error":"Het afbeeldingsformaat wordt niet ondersteund. We ondersteunen alleen JPG, JPEG, PNG en BMP.",
    "watermark_remove_upload_error":"Herkenningsfout (foutcode: 2001), probeer het opnieuw...",
    "watermark_remove_processing":"Afbeelding verwerken...",
    "watermark_remove_not_save":"Het door u geselecteerde gebied blijft niet behouden. Weet je zeker dat je het wilt bijsnijden?",
    "watermark_remove_back_home":"De huidige status wordt niet opgeslagen. Weet je zeker dat je terug wilt naar Home?",
    "watermark_remove_new_image":"De huidige status wordt niet opgeslagen. Weet je zeker dat je een nieuwe afbeelding wilt kiezen?",
    "watermark_select":"Selecteer",
    "watermark_select_area":"Selecteer het gebied van het watermerk dat u wilt wissen voordat u op Verwijderen klikt.",
    "watermark_beyond_4k":"De geselecteerde afbeelding overschrijdt de 4K-resolutie. Het spijt ons dat we het momenteel niet kunnen verwerken",
    "watermark_beyond_pixel_1":"De geselecteerde afbeeldingsresolutie is hoger dan <span>%spx</span><span>&times;%spx</span>. Het kan niet worden verwerkt, selecteer opnieuw.",
    "watermark_beyond_pixel_2":"Bezoekers kunnen alleen <span>%s</span> afbeeldingen verwerken met een resolutie van meer dan <span>%spx</span>x<span>%spx</span>, log in en blijf gebruiken.",
    "watermark_beyond_size_1":"De geselecteerde afbeeldingsgrootte is groter dan <span>%sMB</span>. Het kan niet worden verwerkt, selecteer opnieuw.",
    "watermark_beyond_size_2":"De geselecteerde afbeeldingsgrootte is groter dan <span>%sMB</span>, maar bezoekers kunnen alleen afbeeldingen verwerken die kleiner zijn dan <span>%sMB</span>. Gelieve in te loggen en verder te gebruiken.",
    "no_user_down":"Bezoekers kunnen alleen <span>%s</span> afbeeldingen downloaden met originele kwaliteit. Log in en ga verder met downloaden. Ook kunt u de 7-daagse geschiedenis na het inloggen behouden. Ga door met het downloaden van afbeeldingen die <span>%spx</span> breed of hoog zijn.",
    "no_down_rights":"Kan geen HD-afbeeldingen downloaden met originele kwaliteit, upgrade uw abonnement alstublieft! Je kunt ook doorgaan met het downloaden van afbeeldingen van lage kwaliteit met <span>%spx</span>.",
    "error_40001":"Fout: 40001. Neem contact met ons op",
    "error_40099":"Fout: 40099. Neem contact met ons op",
    "down_btn":"Het downloaden is in voorbereiding, even geduld aub...",
    "noRemove_down_btn":"U heeft niets gedaan voor het verwijderen van watermerken. Selecteer het watermerk dat u wilt verwijderen en klik op de knop Verwijderen. Dan kun je je afbeelding downloaden.",
    "history_open":"De gewijzigde afbeelding openen, even geduld aub...",
    "maskRightsMonitor_info":"De pagina voor het upgraden van voordelen is geopend in een nieuw tabblad en uw abonnement wordt automatisch gesynchroniseerd na het upgraden.",
    "maskLoginMonitor_info":"De landingspagina is geopend, vul a.u.b. de login in. Na succesvol inloggen of registreren, wordt deze pagina automatisch gesynchroniseerd, sluit deze alstublieft niet.",
    "photo_rights_info":"<span><i class=\"num\">2</i> HD-afbeelding(en)</span> met originele kwaliteit kunnen momenteel worden gedownload. <a href=\"https://account.tipard.com\" target=\"_blank\">Details bekijken>></a>",
    "rights_original":"Om de instelling \"Gebruik de functie Beeldverbetering om kwaliteitsverlies te verminderen\" in te schakelen, moet u uw account upgraden!",
    "Brush":"Borstel",
    "Lasso":"Lasso",
    "Polygonal":"veelhoekige",
    "Eraser":"Gom",
    "Free":"Vrij",
    "More":"Meer:",
    "Select":"Selecteer",
    "Remove":"Verwijderen",
    "BrushSize":"Penseelgrootte:",
    "AspectRatio":"Beeldverhouding:",
    "Upload":"Nieuwe foto",
    "History":"Geschiedenis",
    "Login":"Log in",
    "MyAccount":"Mijn rekening",
    "Logout":"Uitloggen",
    "Usinghelp":"Help gebruiken>>",
    "Enhancer":"Gebruik de functie Beeldverbetering om het kwaliteitsverlies te verminderen",
    "Download":"Downloaden",
    "Guide":"Gids",
    "Polygonal1":"Veelhoekig",
    "Polygonal_info":"Klik met de linkermuisknop om een punt tegelijk te identificeren.",
    "Lasso1":"Lasso:",
    "Lasso_info":"Druk lang op de linkermuisknop om het watermerkgebied te lasso.",
    "Brush1":"Borstel:",
    "Brush_info":"Druk lang op de linkermuisknop om precies te selecteren.",
    "Eraser1":"Gom:",
    "Eraser_info":"Wis overbodige delen uit het geselecteerde gebied.",
    "Click":"Klik",
    "the":"de",
    "click_info":"om het ongewenste watermerk te wissen.",
    "PleaseUploadImages":"Upload alstublieft afbeeldingen.",
    "CropInfo":"Zodra het verwijderen van het watermerk is voltooid, kunt u op de knop Bijsnijden klikken om uw afbeelding bij te snijden voordat u deze opslaat, of op de knop Downloaden klikken om de huidige afbeelding direct op te slaan.",
    "Crop":"Bijsnijden",
    "Back":"Rug",
    "DownloadCropped":"Bijgesneden downloaden",
    "Cancel":"Annuleren",
    "FreeWatermarkRemover":"Gratis watermerkverwijderaar",
    "Processing":"Verwerken...",
    "NewImage":"Nieuw beeld",
    "Retry":"Opnieuw proberen",
    "Yes":"Ja",
    "No":"Nee",
    "FailureFeedback":"Feedback bij fouten",
    "removeTip":"Nadat u het watermerkgebied hebt geselecteerd, klikt u op Verwijderen om het watermerk te wissen.",
    "rightDown":"Download afbeeldingen van lage kwaliteit",
    "history_will":"Verloopt na",
    "Expired":"(Verlopen)",
	"uploadImage":"Afbeelding toevoegen",
    "uploadImageInfo":"Of zet je afbeeldingsbestand hier neer om het watermerk te verwijderen!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain THREE HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Onbeperkt",
    "watermark_beyond_pixel_3":"De geselecteerde afbeelding overschrijdt de <span>%s&times;%s resolutie</span>, upgrade eerst uw abonnement.",
    "watermark_beyond_size_3":"De geselecteerde afbeelding is groter dan <span>%sMB</span>, upgrade eerst je abonnement.",
    "no_user_login":"Nieuwe gebruikers die inloggen, kunnen profiteren van TWEE voordelen voor het downloaden van originele HD-afbeeldingen.<span class=\"loginMaskbtn\">Onmiddellijk inloggen>></span>",
    "Upgrade":"Upgrade",
    "Loading":"Bezig met laden…",
    "SelectAll":"Selecteer alles",
    "Open":"Open",
    "Delete":"Verwijderen",
    "Clear":"Wis ongeldig",
    "noHistory":"Geen geschiedenis",
    "Close":"Dichtbij",
    "buyUserInfo":"gefeliciteerd! Je hebt succesvol geüpgraded. Ga terug naar de startpagina en gebruik dit product.",
    "buyNoUserInfo":"Gefeliciteerd! Je hebt succesvol geüpgraded. De voordelen zijn gekoppeld aan het e-mailadres dat je hebt achtergelaten tijdens het upgraden. Gebruik het geregistreerde of gekoppelde account aan het e-mailadres om <span class=\"loginMaskbtn\">in te loggen voor het gebruik van voordelen</span>. Als u zich niet heeft geregistreerd of geen account hebt gekoppeld met het e-mailadres, <span class=\"registerMaskbtn\">gebruik dan het e-mailadres om een account te registreren</span> of koppel andere accounts aan dit e-mailadres mailadres voor het gebruik van voordelen.",
    "GetStarted":"Begin",
    "AccessTo":"Toegang tot:",
    "imagesOfwatermarkremoval":"afbeeldingen van het verwijderen van het watermerk",
    "upTo":"Tot",
    "perImage":"per afbeelding",
    "Support":"Steun",
    "resolution":"oplossing",
    "PrepaidPackage":"Prepaid pakket",
    "PayasYouGo":"Betaal naar gebruik",
    "TaxIncl":"Incl. btw.",
    "Checkout":"Uitchecken",
    "imagesDay":"afbeeldingen/dag",
    "imagesMonthly":"afbeeldingen/maandelijks",
    "image":"afbeelding",
    "images":"afbeeldingen",
    "imageSize":"afbeeldingsgrootte",
    "buyInfo1":"<span>enhancer</span>-integraties van derden",
    "buyInfo2":"Bewerkingsgeschiedenis is 7 dagen geldig",
    "buyInfo3":"Prioritaire verwerking",
    "buyInfo4":"7x24 klantenondersteuning",
    "buyInfo5":"Verlopen na 24 uur",
    "buyInfo6":"Geen abonnement. Geen automatische verlenging!",
    "buyInfo7":"Altijd en altijd beschikbaar voor gebruik",
    "dayPlan":"1-dagplan",
    "Lifetime":"Levenslang",
    "note":"<span>Let op</span>: Houd er rekening mee dat het gekochte plan gekoppeld is aan het e-mailadres dat u bij het afrekenen hebt opgegeven. Om het plan succesvol te gebruiken, registreert u zich of logt u in met hetzelfde e-mailadres.",
    "buy_now": "Nu kopen",
    
    "banner_title": "AI Foto -opruiming - Hoeveel credits u wilt",
    "banner_info": "1 credit = 1 afbeelding: u kost 1 krediet om een afbeelding te verwerken en op te slaan die groter is dan 600 × 600 pixels. ",
    "monthlyPlan_title": "Maandelijks plan",
    "monthlyPlan_displayPricePerCredit": "/credit",
    "monthlyPlan_plan1_credits": "credits/mo",
    "monthlyPlan_feature1": "<span> Risico-vrij: </span> 30-daagse geld-terug-garantie",
    "monthlyPlan_feature2": "<span> Automatisch: </span> Credits worden automatisch verlengd",
    "monthlyPlan_feature3": "<span> Flexibel: </span> Downgrade, upgrade of annuleer elk moment",
    "oneTimePurchase_title": "Eenmalige aankoop",
    "oneTimePurchase_plan5_credits": "Credits/levenslang",
    "oneTimePurchase_feature1": "30-daagse geld-back garantie",
    "oneTimePurchase_feature2": "Permanent geldig na aankoop",
    "payment_title": "U kunt meerdere betaalmethoden kiezen",
    "payment_image_alt": "Betaalmethoden",
    "faq_title": "Veelgestelde vragen over creditsaankoop",
    "faq_question1_title": "Wat zijn credits?",
    "faq_question1_info": "Onze service wordt gemeten in de eenheid van credits. ",
    "faq_question2_title": "Moet ik een maandelijks abonnement of een eenmalige aankoop kiezen?",
    "faq_question2_info": "Voor onregelmatige beeldtaken of een zeldzame gebruikseis, kunt u een eenmalige aankoop kiezen, waar u de juiste hoeveelheid credits kunt kopen op basis van uw beeldvereisten. ",
    "faq_question3_title": "Wat als ik mijn credits gebruik?",
    "faq_question3_info": "U kunt uw abonnement upgraden of een eenmalig aankoopplan blijven kopen op basis van uw fotowerkeringsbehoeften. ",
    "faq_question4_title": "Kan ik mijn abonnement upgraden, downgraden of annuleren?",
    "faq_question4_info": "Ja, dat kan. ",
    "whyChoose_title": "Waarom kiezen voor Tipard",
    "whyChoose_reason1_title": "Veilig download",
    "whyChoose_reason1_info": "Programma's van Tipard zijn 100% schoon en veilig",
    "whyChoose_reason2_title": "Professionele technologie",
    "whyChoose_reason2_info": "Skilled Team biedt professionele producten",
    "whyChoose_reason3_title": "24/7 klantenondersteuning",
    "whyChoose_reason3_info": "Patiëntconsulentdiensten altijd",
    "whyChoose_reason4_title": "30 dagen geld terug",
    "whyChoose_reason4_info": "Garandeer terugbetaling aan gebruikers in 30 dagen",
    "whyChoose_reason5_title": "1.000.000+ gebruikers",
    "whyChoose_reason5_info": "Gebruikt en vertrouwd door meer dan 1 miljoen mensen",
    "whyChoose_reason6_title": "160+ landen",
    "whyChoose_reason6_info": "Verkocht in meer dan 160 landen en regio's"
}